import getService from '../../../services/get_services/getService';
import HomeCustomModal from '../../molecules/modals/first_time_modal_home/first-time-custom-modal/HomeCustomModal';
import SliderParent from '../../organisms/SliderParent';
import { useEffect, useState } from 'react';

export const BASE_URL_IMG = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_API_DEV_IMG_BASE_URL
  : process.env.REACT_APP_API_PROD_IMG_BASE_URL;

const Home = () => {
  const [showFirstTimeModalHome, setShowFirstTimeModalHome] = useState(true);

  const [modalImg, setModalImg] = useState({
    img: '',
    active: false
  });

  const getModalHomeDetails = async () => {
    const url = '/modal-home/get-details';
    const response = await getService(url);

    const homeModalDetails = response?.data?.homeModalDetails || null;
    if (homeModalDetails && homeModalDetails.imgUrl) {
      setModalImg({
        img: `${BASE_URL_IMG}${homeModalDetails.imgUrl}` || '',
        active: homeModalDetails.active ?? false
      });
    }
  };

  useEffect(() => {
    getModalHomeDetails();
  }, []);

  return (
    <div>
      <SliderParent />
      {modalImg.active && modalImg.img && (
        <HomeCustomModal
          modalImgUrl={modalImg.img}
          showFirstTimeModalHome={showFirstTimeModalHome}
          setShowFirstTimeModalHome={setShowFirstTimeModalHome}
        />
      )}
      {/* <OpeningHoursModal
        showFirstTimeModalHome={showFirstTimeModalHome}
        setShowFirstTimeModalHome={setShowFirstTimeModalHome}
      /> */}
    </div>
  );
};

export default Home;
